import { CruiseBookKind, CruiseGuest, CruiseHit, CruiseStep } from '../cruises.types';
import { CruiseSearchForm } from './cruises.model';

/** Cruises phase 4 - the actions of the Cruises tab (W1-W6). QA doc: docs/features/cruises/qa.md R-47 … R-57. */

export class cruisesReset {
  static readonly type = '[Cruises] Reset';
}

export class cruisesLoadSearchOptions {
  static readonly type = '[Cruises] LoadSearchOptions';
  constructor(public refresh = false) {}
}

export class cruisesSetSearchForm {
  static readonly type = '[Cruises] SetSearchForm';
  constructor(public patch: Partial<CruiseSearchForm>) {}
}

export class cruisesClearSearchForm {
  static readonly type = '[Cruises] ClearSearchForm';
}

/** W1: one search per click, for the guests of the form (R-1). */
export class cruisesSearch {
  static readonly type = '[Cruises] Search';
}

/** W1 → W2: the sailing of a result card, priced for the searched guests. */
export class cruisesOpenSailing {
  static readonly type = '[Cruises] OpenSailing';
  constructor(public hit: CruiseHit) {}
}

export class cruisesReloadSailing {
  static readonly type = '[Cruises] ReloadSailing';
  /** R-56a: a language switch re-asks silently - the shown sailing stays until the new answer, and a failure keeps it. */
  constructor(public silent = false) {}
}

/** W2: a cell of the matrix - our cabin type × our fare family, at the catalogue price (R-50). */
export class cruisesSelectOffer {
  static readonly type = '[Cruises] SelectOffer';
  constructor(public offerKey: string) {}
}

/**
 * R-3: ask the supplier now. `compare` = the agency pressed "Get live price": a total that differs from the one on the screen for the same
 * offer and guests opens the price-changed dialog; a re-ask after a package or guest change just takes the new answer.
 */
export class cruisesGetLivePrice {
  static readonly type = '[Cruises] GetLivePrice';
  constructor(public compare = true) {}
}

export class cruisesAcceptPriceChange {
  static readonly type = '[Cruises] AcceptPriceChange';
}

export class cruisesDeclinePriceChange {
  static readonly type = '[Cruises] DeclinePriceChange';
}

export class cruisesGoTo {
  static readonly type = '[Cruises] GoTo';
  constructor(public step: CruiseStep) {}
}

export class cruisesSetCabin {
  static readonly type = '[Cruises] SetCabin';
  constructor(public cabinNumber: string | null) {}
}

export class cruisesSetDining {
  static readonly type = '[Cruises] SetDining';
  constructor(public diningKey: string | null) {}
}

export class cruisesUpdateGuest {
  static readonly type = '[Cruises] UpdateGuest';
  constructor(
    public seq: number,
    public patch: Partial<Omit<CruiseGuest, 'seq' | 'rftid'>>
  ) {}
}

export class cruisesAddGuest {
  static readonly type = '[Cruises] AddGuest';
}

export class cruisesRemoveGuest {
  static readonly type = '[Cruises] RemoveGuest';
  constructor(public seq: number) {}
}

/** W4: the check of the typed guests (R-5) - nothing is registered or held. */
export class cruisesCheckGuests {
  static readonly type = '[Cruises] CheckGuests';
}

export class cruisesSetPackage {
  static readonly type = '[Cruises] SetPackage';
  constructor(
    public packageId: string,
    public guestSeq: number,
    public selected: boolean
  ) {}
}

/** W6: check → register (once) → quote / option (R-54). `expectedPrice` = the new price the agency accepted in the dialog. */
export class cruisesBook {
  static readonly type = '[Cruises] Book';
  constructor(
    public kind: CruiseBookKind,
    public expectedPrice: number | null = null
  ) {}
}

/** W4's citizenship picker: the site's own country list. */
export class cruisesLoadCountries {
  static readonly type = '[Cruises] LoadCountries';
  constructor(public refresh = false) {}
}
